<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
            <el-form-item label="报表名称">
                <el-input v-model="queryForm.reportName" placeholder="请输入报表名称" style="width: 175px" />
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getReportDailyList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                     <el-button type="primary" size="small" icon="el-icon-plus" @click="addShopProduct">新建</el-button>
                </div>
                <div class="icon-group">
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <span
                        class="icon-box"
                        @click="refreshReportDailyList"
                    >
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <el-table
                height='100%'
                :data="reportTableList"
                row-key="id"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    min-width="10%"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="reportName"
                    label="报表名称"
                    width="180px"
                >
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="reportName"
                    label="子项"
                    min-width="180px"
                >
                    <template slot-scope='scope'>
                        <div>{{subitemCompute(scope.row.itemList)}}</div>
                    </template>
                </el-table-column>


                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    min-width="180px"
                >
                    <template slot-scope="scop">
                        <div class="operation">
<!--                            <div>-->
<!--                                <Icon size="16">-->
<!--                                    <Eye24Regular />-->
<!--                                </Icon>-->
<!--                                <span class="operation-label">查看</span>-->
<!--                            </div>-->
                            <div @click="maintainReportTableItem(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular/>
                                </Icon>
                                <span class="operation-label">维护</span>
                            </div>
                            <div @click="editReportTableItem(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular/>
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteReportTableItem(scop.row.id)">
                                <Icon
                                    size="16"
                                    style="color: red"
                                >
                                    <Delete24Regular />
                                </Icon>
                                <span
                                    class="operation-label"
                                    style="color: red"
                                >删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="reportTableItemStates[reportTableItemState]"
                :visible.sync="showDialog"
                width="400px"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="reportTableItem"
                        ref="reportTableItemForm"
                        :rules="rules"
                        label-width="80px"
                        :inline="true"
                        size="small"
                    >
                        <el-form-item
                            label="报表名称"
                            prop="reportName"
                        >
                            <el-input
                                size="small"
                                style="width:200px"
                                v-model="reportTableItem.reportName"
                                :disabled="reportTableItemState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <!-- <el-form-item
                            label="商品类型"
                            prop="productType"
                        >
                            <el-select
                                style="width:200px"
                                v-model="reportTableItem.productType"
                                :disabled="reportTableItemState == 'check'"
                                size="small"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="(item,index) in productTypeEnumList"
                                    :key="index"
                                    :label="item.value"
                                    :value="item.key"
                                > </el-option>
                            </el-select>
                        </el-form-item> -->
                    </el-form>
                </div>
                <div
                    slot="footer"
                    class="flex justify-end"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="reportTableItemState != 'check'"
                    >确定</el-button>
                </div>
            </el-dialog>
            <!--维护子项-->
            <MaintainItem ref="MaintainItem" @resetDialog="resetDialog"></MaintainItem>
        </div>
    </div>
</template>
<script>
import MaintainItem from '@/components/system/MaintainItem.vue';
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        MaintainItem
    },
    data(){
        return{
            productTypeEnumList: [],
            isSearch: false, // 搜索
            showDialog: false, // 表单显示隐藏

            queryForm:{
                reportName:''
            },
            reportTableList:[],
            reportTableItemList:[],
            reportTableSelection:[],
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            rules: {
                reportName: [{ required: true, message: '报表名称不能为空', trigger: 'blur' }],
            },
            reportTableItem:{
                reportName:'',
                // productType:'',
            },
            reportTableItemState: 'add',
            reportTableItemStates: {
                add: '新建',
                edit: '修改'
            },
        }
    },
    created() {
        //this.getReportTableItem();
        this.getReportTableFindList();
        // this.getProductTypeEnum();
    },
    methods:{
        // 搜索
        search(){
            this.isSearch = !this.isSearch
        },

        // 重置
        refreshReportDailyList(){
            this.resetReportTableList();
            this.getReportTableFindList();
        },

        getReportTableFindList(){
            get('/report/reporttable/findList',{...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize}).then((res)=>{
                if(res.success){
                    this.reportTableList = res.page.list
                }
            })
        },

        getReportTableItem(){
            get('/report/reporttableitem/findAll').then((res)=>{
                if(res.success){
                    this.reportTableItemList = res.list
                }
            })
        },

        getReportTable(id){
            get('/report/reporttable/get',{
                id:id,
            }).then((res)=>{
                if(res.success){
                    this.reportTableItem = {...res.reportTable}
                }
            })
        },

        // 新建
        addShopProduct(){
            this.showDialog = true
            this.reportTableItemState = 'add'
        },

        subitemCompute(list){
            return list.map(item=>item.itemName).join(",")
        },

        handleSelectionChange(value) {
            console.log(value);
            this.reportTableSelection = value;
        },

        sizeChange(size) {
            this.pageSize = size;
            this.getReportTableFindList();
        },

        currentChange(page) {
            this.currentPage = page;
            this.getReportTableFindList();
        },

        // 查询
        getReportDailyList(){
            this.getReportTableFindList();
        },

        // 重置
        resetDialog(){
            this.queryForm = {
                reportName:''
            }
            this.resetReportTableList();
            this.getReportTableFindList();
        },

        resetReportTableList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.reportTableList = [];
        },

        // 关闭表单
        closeDialog(){
            this.showDialog = false
            this.reportTableItemState = 'add'
            this.reportTableItem = {
                reportName:'',
                // productType:'',
            }
        },

        // 表单确定
        submitForm(){
            if (this.reportTableItemState == 'add') {
                this.$refs.reportTableItemForm.validate((valid) => {
                    if (valid) {
                        post('/report/reporttable/add',this.reportTableItem).then((res)=>{
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetReportTableList();
                                this.getReportTableFindList();
                                this.closeDialog();
                            }
                        })
                    }
                });
            } else if (this.reportTableItemState == 'edit') {
                this.$refs.reportTableItemForm.validate((valid) => {
                    if (valid) {
                        let params = {
                            reportName: this.reportTableItem.reportName,
                            id: this.reportTableItem.id
                        }
                        post('/report/reporttable/edit',{ ...params}).then((res)=>{
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetReportTableList();
                                this.getReportTableFindList()
                                this.closeDialog();
                            }
                        })
                    }
                });
            }
        },

        // 修改
        editReportTableItem(id){
            this.getReportTable(id)
            this.showDialog = true
            this.reportTableItemState = 'edit'
        },

        // 删除
        deleteReportTableItem(reportTableid){
            let ids = '';
            if (reportTableid) {
                ids = reportTableid;
            } else {

            }

            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/report/reporttable/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetReportTableList();
                            this.getReportTableFindList();
                        }
                    });
                })
                .catch(() => {
                });
        },

        // 维护表单显示
        maintainReportTableItem(id){
            get('/report/reporttable/get',{
                id:id,
            }).then((res)=>{
                if(res.success){
                    this.$refs.MaintainItem.show(res.reportTable.itemList,id);
                }
            })
        },

        //  获取商品类型枚举
        getProductTypeEnum(){
            get('/mpp/utils/getEnum',{
                enumType: 'product_type',
            }).then((res)=>{
                if(res.success){
                    this.productTypeEnumList = res.enumList
                }
            })
        },
    }
}
</script>
<style lang='scss' scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}


</style>
